import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { trashProject } from "../../../redux/ducks/project";

const TrashProject = props => {
    const [show, hide, renderModal] = useModal();
    const [d_trashProject, status, error, event] = useStatusThunk(trashProject);

    event.onSuccess = () => hide();

    return (
        <React.Fragment>

            <button className="button icon-button button--danger" onClick={show}>
                <i className="fas fa-trash icon"></i>
            </button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="warning">
                            This will remove every assosiated task, as well as the assosiated file. <br />Are you sure?
                        </div>
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--danger" onClick={() => { d_trashProject({ projectID: props.projectID }) }}>Trash Project</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default TrashProject;